import { type APIResponse, type MatterStatus } from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

type CreateMatterStatusPayload = {
  categoryId: string;
  defaultAttorneyFee?: number | null;
  description?: string | null;
  goal?: number | null;
  label: string;
  order?: number | null;
};

type UpdateMatterStatusPayload = Partial<CreateMatterStatusPayload> &
  Pick<MatterStatus, "id" | "dateModified">;

export const createMatterStatusV1 = (data: CreateMatterStatusPayload) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterStatus>>(`${baseFastApiMatterRoute}/statuses`, data)
    .then((res) => res.data);
};

export const updateMatterStatusV1 = (data: UpdateMatterStatusPayload) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterStatus>
    >(`${baseFastApiMatterRoute}/statuses`, data)
    .then((res) => res.data);
};

export const deleteMatterStatusV1 = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterStatus>
    >(`${baseFastApiMatterRoute}/statuses/${id}`)
    .then((res) => res.data);
};

export const updateMatterStatusOrders = (data: {
  categoryId: string;
  statuses: Array<
    Pick<MatterStatus, "id" | "dateModified"> & { order: number }
  >;
}) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterStatus[]>
    >(`${baseFastApiMatterRoute}/statuses/orders`, data)
    .then((res) => res.data);
};

export type CreateMatterStatusPhaseInput = {
  dateTimeStart: string;
  matterId: string;
  statusId: string;
};

export const createMatterStatusPhase = (data: CreateMatterStatusPhaseInput) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterStatus>
    >(`${baseFastApiMatterRoute}/statuses/phases`, data)
    .then((res) => res.data);
};
